<template>
  <b-container ref="bodywidth" class="m-0 p-0">
    <div class="sflcon mt-3">
      <div class="colodiv p-2">
        <div class="color">
          <b-avatar class="big-avatar" :badge="position.toString()" size="4rem"></b-avatar>
          <b-avatar class="small-avatar" :badge="position.toString()" size="1.5rem"></b-avatar>
        </div>
      </div>
      <div class="detailsdiv">
        <div class="userdet pl-0 p-2">
          <div class="namedet">
            <div class="nflex">
              <b-icon-trophy-fill class="mr-2" v-if="position == 1" color="gold" />
              <b-icon-gem class="mr-2" v-if="position == 2" color="silver" />
              <b-icon-stars class="mr-2" v-if="position == 3" color="brown" />

              {{ leaderboard.user_name }} 
              
            </div>
            <div class="bflex">
              {{
                leaderboard.total_tests
              }}
              <p class="base-headings">Tests taken</p>
            </div>

            <div class="bflex">
              {{
                leaderboard.alltime_qts
              }}
              <p class="base-headings">Alltime QTs</p>
            </div>

            <div class="bflex">
              {{
                leaderboard.current_qts
              }}
              <p class="base-headings">This Month QTs</p>
            </div>
          </div>
        </div>
        <!-- <div class="scoredet p-2">
          <img v-if="position <= 3" style="width:100px;height:60px" src="@/assets/goldenTrophy2.png" class="trophy-image" />
        </div> -->
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  props: ["leaderboard", "keys", "page", "perPage"],
  data() {
    return {
      randnum: Math.round(Math.random(1, 10) * 5),
      colorarr: ["red", "yellow", "green", "purple", "blue", " bluedepth"],
      bodywidth : null
    };
  },
  computed: {
    position(){
      return (this.page - 1) * this.perPage + (this.keys + 1)
    },
    variant() {
      if (this.leaderboard.total_score >= 70) {
        return "success";
      } else if (
        this.leaderboard.total_score >= 50 &&
        this.leaderboard.total_score < 70
      ) {
        return "primary";
      } else if (
        this.leaderboard.total_score >= 40 &&
        this.leaderboard.total_score < 50
      ) {
        return "info";
      } else if (
        this.leaderboard.total_score >= 20 &&
        this.leaderboard.total_score < 40
      ) {
        return "warning";
      } else if (
        this.leaderboard.total_score >= 0 &&
        this.leaderboard.total_score < 20
      ) {
        return "danger";
      } else {
        return "secondary";
      }
    },
    size() {
      if (window.outerWidth < 768) {
        return "2rem";
      } else {
        return "4rem";
      }
    }
  }
};
</script>

<style scoped>
.sflcon {
  display: flex;
  border-bottom: 1px solid rgba(160, 159, 159, 0.659);
}

.colodiv {
  width: 10%;
}

.detailsdiv {
  width: 90%;
}

.color {
  width: 100%;
  border-radius: 10px 10px;
}

.detailsdiv {
  display: flex;
}

.userdet {
  width: 100%;
}

.scoredet {
  width: 10%;
  text-align: right;
}

.scorebadge {
  font-size: 1.7rem;
}

.namedet {
  font-size: 1.5rem;
  display: flex;
}

.nflex {
  width: 50%;
  margin-top:8px;
}

.bflex {
  width: 30%;
  text-align: left;
}

.instidet {
  margin-top: -20px;
  font-size: 0.9rem;
}
.big-avatar{
  display: block
}
.small-avatar{
  display:none
}

.base-headings{
  font-size:14px;
}

@media screen and (max-width: 768px) {
  .scorebadge {
    font-size: 1.3rem;
    margin-top: 0.35rem;
  }

  .namedet {
    font-size: 1.2rem;
  }

  .scoredet {
    margin-right: 1.3rem;
  }
  .colodiv {
    width: 10%;
  }
  .bflex{
    font-size: 16px
  }

  .nflex{
    font-size: 12px;
    margin-top:3px;
  }

  .big-avatar{
    display:none;
  }
  .small-avatar{
    display:block
  }
  .base-headings{
    font-size:8px;
  }
  .sflcon {
    height: 60px;
  }
}
</style>
